import IdBadge from './IdBadge';

export default IdBadge;
